import { Component, Input } from '@angular/core';
import { I3OpenWorkOrder } from '../../../../../api/intelli360/models/i3-open-work-orders.model';

@Component({
    selector: 'toro-i3-work-order-card',
    templateUrl: './i3-work-order-card.component.html',
    styleUrls: ['./i3-work-order-card.component.less']
})
export class I3WorkOrderCardComponent {

    @Input() workOrder: I3OpenWorkOrder;

}
